import { render, staticRenderFns } from "./OrderCheckout.vue?vue&type=template&id=f5e827da"
import script from "./OrderCheckout.vue?vue&type=script&lang=js"
export * from "./OrderCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports